import React, {Component} from "react";
import PropTypes from "prop-types";
import Form from 'react-bootstrap/Form';
import ConnectsTo from "../ConnectsTo";
import {Button, InputGroup} from "react-bootstrap";
import {FaRegTrashAlt} from "react-icons/fa";

class ADSREnvelope extends Component {
  static propTypes = {
    config: PropTypes.object,
    connectables: PropTypes.array,
    deleteTool: PropTypes.func,
    setToolConfig: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {};

    this.setAttack = this.setAttack.bind(this);
    this.setDecay = this.setDecay.bind(this);
    this.setSustain = this.setSustain.bind(this);
    this.setRelease = this.setRelease.bind(this);
    this.setToolId = this.setToolId.bind(this);
  }

  setAttack = (event) => {
    this.props.config.attack = parseFloat(event.target.value);
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  setDecay = (event) => {
    this.props.config.decay = parseFloat(event.target.value);
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  setSustain = (event) => {
    this.props.config.sustain = parseFloat(event.target.value);
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  setRelease = (event) => {
    this.props.config.release = parseFloat(event.target.value);
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  setToolId = (event) => {
    const newToolId = event.target.value;
    let config = Object.assign({}, this.props.config);
    config.id = newToolId;
    this.props.setToolConfig(this.props.config.id, config);
  }

  render() {
    return (
        <div className={"gain toolChainTool"}>
          <h3>ADSR Envelope</h3>
          <Button variant={"danger"} onClick={() => {this.props.deleteTool(this.props.config.id)}}><FaRegTrashAlt /></Button>
          <InputGroup>
            <InputGroup.Text>id</InputGroup.Text>
            <Form.Control type="text" value={this.props.config.id}
                          onChange={this.setToolId}/>
          </InputGroup>
          <InputGroup>
            <InputGroup.Text>Attack</InputGroup.Text>
            <Form.Control type="number" min={0} max={5} step={.01}
                          value={this.props.config.attack}
                          onChange={this.setAttack}/>
          </InputGroup>
          <InputGroup>
            <InputGroup.Text>Decay</InputGroup.Text>
            <Form.Control type="number" min={0} max={5} step={.01}
                          value={this.props.config.decay}
                          onChange={this.setDecay}/>
          </InputGroup>
          <InputGroup>
            <InputGroup.Text>Sustain</InputGroup.Text>
            <Form.Control type="number" min={0} max={5} step={.01}
                          value={this.props.config.sustain}
                          onChange={this.setSustain}/>
          </InputGroup>
          <InputGroup>
            <InputGroup.Text>Release</InputGroup.Text>
            <Form.Control type="number" min={0} max={5} step={.01}
                          value={this.props.config.release}
                          onChange={this.setRelease}/>
          </InputGroup>
          <ConnectsTo
              connectables={this.props.connectables}
              config={this.props.config}
              setToolConfig={this.props.setToolConfig}/>
        </div>
    );
  }
}

export default ADSREnvelope;